const Auth = {
  // A
  automate_your_hr_operations_and_focus_on_your_business:
    'أتمتة عمليات الموارد البشرية لتركزّ على<br /> نمو شركتك',
  attendance: 'الحضور و الغياب',
  // B
  // C
  code_valid_until: '<b>رمز التحقق</b> صالح لمدة <b>{{time}}</b> دقيقة.',
  confirm_password: 'تأكيد كلمة المرور الجديدة',
  current_password: 'كلمة المرور الحالية',
  password_complexity_note:
    'يجب أن تستخدم كلمات المرور ثلاثة على الأقل من أنواع الأحرف الأربعة المتاحة ، وهي <b>أحرف صغيرة</b> و<b>أحرف كبيرة</b> و<b>أرقام</b> و<b>رموز</b>. <br /><br /> لايمكن أن تحتوي كلمة المرور على <b>الاسم الأول</b> أو <b>اسم العائلة</b> أو <b>عنوان البريد الإلكتروني للمستخدم</b>.',
  minimum_password_length_note: 'كلمة المرور يجب ان تكون ٨ أحرف كحد أدنى.',
  // D
  didn_recieve_an_email: 'لم يصلك البريد الإلكتروني؟',
  // E
  enter_six_digit_code: 'أدخل رمز التحقق المكون من ٦ أرقام',
  email: 'البريد الإلكتروني',
  // F
  forgot_password: ' هل نسيت كلمة المرور؟',
  // G
  // H
  hr_management: 'إدارة الموارد البشرية',
  // I
  // J
  jisr_login_authentication: 'مصادقة تسجيل الدخول لنظام {{name}}',
  // K
  keep_me_logged_in_for_30_days: 'حفظ الدخول لمدة ٣٠ يوم',
  // L
  login: 'تسجيل الدخول',
  login_six_digit_code_note:
    'تم إرسال  رمز التحقق المكون من 6 أرقام على بريدك الإلكتروني. من فضلك ، تحقق منه وأدخل رمزًا مكونًا من ستة أرقام أدناه',
  login_with_office365: 'تسجيل دخول عن طريق Office365',
  // M
  // N
  new_password: 'كلمة المرور الجديدة',
  // O
  OR: 'أو',
  // P
  password: 'كلمة المرور',
  // Q
  // R
  reports_and_more: 'تقارير مفصلة وأكثر',
  resend_new_password_creation_link: 'إعادة إرسال رابط إنشاء كلمة المرور',
  resend_new_code: 'إعادة إرسال رمز جديد',
  // S
  submit: 'إرسال',
  slug: 'إسم الشركة',
  sso_login: 'تسجل الدخول SSO',
  // T
  two_factor_verification: 'تأكيد المصادقة الثنائية',
  time_session_out: 'تحديد وقت إنتهاء الجلسة',
  time_session_out_description:
    'سيتم تسجيل الخروج من الحساب  بعد 4 ساعات في حالة عدم وجود أي إجراء في الصفحة.',
  try_again: 'أرسل مرة أخرى',
  // U
  // V
  visit_our_knowledgebase: 'قم بزيارة قاعدة المعرفة الخاصة بنا',
  // W
  // X
  // Y
  exceeded_tallowed_attempts:
    'استنفذت عدد المحاولات المسموحة للدخول لحسابك، يمكنك تغيير كلمة المرور لتنشيط الحساب.',
  // Z

  application: {
    login: 'Login for {{name}}',
  },
  date: {
    long: 'MMMM Do, YYYY',
  },
  two_lines: 'Line 1<br />Line 2',
}

export default Auth
